<template>
    <component :is="tag" :class="computedClasses">
        <slot />
    </component>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";

interface Props {
    tag?: "p" | "span" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
    variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "body" | "body2" | "caption" | "subtitle" | "subtitle2";
    className?: string;
}

const props = withDefaults(defineProps<Props>(), {
    tag: "p",
    variant: undefined,
    className: "",
});

const computedVariant = computed(() => {
    if (props.variant) return props.variant;
    if (props.tag === "p") return "body";
    if (props.tag === "span") return "subtitle";
    return props.tag;
});

const classList: Record<string, string> = {
    h1: "font-serif text-3xl font-bold text-neutral-700",
    h2: "font-serif text-2xl font-bold text-neutral-700",
    h3: "font-serif text-2xl font-bold text-neutral-700",
    h4: "font-serif text-xl font-bold text-neutral-700",
    h5: "font-serif text-lg font-bold text-neutral-700",
    h6: "font-bold text-neutral-700",
    body: "text-neutral-600",
    body2: "text-sm text-neutral-600",
    caption: "text-xs font-bold text-neutral-400",
    subtitle: "text-sm text-neutral-500",
    subtitle2: "text-xs text-neutral-500",
};

const computedClasses = computed(() => {
    const baseClass = classList[computedVariant.value];
    return twMerge(baseClass, props.className);
});
</script>
